import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(ScrollTrigger);



// GSAP Animations

let stickerTL = gsap.timeline({scrollTrigger: {
        trigger: ".sticker_container",
        start: "top 60%"
    }});
    stickerTL
    .from(".photo_sticker", {duration: 0.65, opacity: 0, rotation: 32, transformOrigin: "40% 70%", ease: "back.out(2)"})
    .from(".yes_sticker", {duration: 0.2, opacity: 0, ease: "none"}, "-=0.3")
    .from(".yes_sticker", {duration: 0.8, scale: 1.2, rotation: 18, transformOrigin: "75% 75%", ease: "bounce.out"}, "<")

async function initializeSplitTextAnim(): Promise<void> {

    // Wait for fonts to load before creating SplitText
    if ('fonts' in document) {
        try {
            await Promise.race([
                document.fonts.ready,
                new Promise(resolve => setTimeout(resolve, 2000)) // 2 second timeout
            ]);
        } catch (error) {
            console.warn('Font loading failed, proceeding anyway:', error);
        }
    }

    let split = SplitText.create(".inspire-anim", {
        type: "words",
        mask: "words", // adds extra wrapper element around lines with overflow: clip
        wordsClass: "word++" // class name for word elements
    });
    
    let splitChars1 = SplitText.create(".inspire-anim h2 .word7", {
        type: "chars"
    });

    function textRevert() {
        split.revert();
        splitChars1.revert();
    }

    let inspireTimeline = gsap.timeline({onComplete: textRevert, scrollTrigger: {
            trigger: ".inspire-anim",
            start: "top 60%"
        }});
        inspireTimeline
        .set(".inspire-anim", {opacity:1})
        .from(split.words, {yPercent: 100, ease: "power2", duration: 0.6, stagger: 0.15})
        .to(splitChars1.chars, {duration: 0.75, color: "var(--color-neon)", stagger: {each: 0.1, yoyo: true, repeat: 1, repeatDelay: 1}, ease: "power1.inOut"}, "-=0.2")  

}

// Initialize animations when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    initializeSplitTextAnim();
});

// Custom modal functionality for culture page

// Function to show modal with custom animations
function showModal(modalId: string) {
  const modal = document.getElementById(modalId);
  if (!modal) {
    console.error(`Modal not found: ${modalId}`);
    return;
  }

  console.log(`Opening modal: ${modalId}`);

  // Create and show backdrop
  const backdrop = document.createElement('div');
  backdrop.className = 'modal-backdrop';
  backdrop.id = `${modalId}-backdrop`;
  document.body.appendChild(backdrop);

  // Show modal
  modal.style.display = 'flex';
  modal.classList.add('show');

  // Trigger backdrop animation
  requestAnimationFrame(() => {
    backdrop.classList.add('show');
  });

  // Add click handler for backdrop
  backdrop.addEventListener('click', () => hideModal(modalId));
}

// Function to hide modal with custom animations
function hideModal(modalId: string) {
  const modal = document.getElementById(modalId);
  const backdrop = document.getElementById(`${modalId}-backdrop`);

  if (!modal) return;

  console.log(`Closing modal: ${modalId}`);

  // Add hiding class for animations
  modal.classList.add('hiding');
  if (backdrop) {
    backdrop.classList.add('hiding');
  }

  // Wait for animation to complete
  setTimeout(() => {
    // Hide modal
    modal.style.display = 'none';
    modal.classList.remove('show', 'hiding');

    // Remove backdrop
    if (backdrop) {
      backdrop.remove();
    }

    // NO BODY CLASS REMOVAL - scrolling remains normal
  }, 300); // Match CSS animation duration
}

// Initialize modal functionality
document.addEventListener('DOMContentLoaded', () => {
  // Only initialize on culture pages
  if (!document.querySelector('.motech.culture')) {
    return;
  }

  console.log('Initializing custom culture modals...');

  // Add click handlers to all leadership divs
  const leadershipDivs = document.querySelectorAll('[data-modal]');

  leadershipDivs.forEach(div => {
    const modalId = div.getAttribute('data-modal');

    if (modalId) {
      div.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        showModal(modalId);
      });
    }
  });

  // Global event delegation for modal close functionality
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;

    // Handle close button clicks (both desktop and mobile)
    if (target.classList.contains('modal-close-desktop') ||
      target.classList.contains('modal-close-mobile') ||
      target.closest('.modal-close-desktop') ||
      target.closest('.modal-close-mobile')) {

      e.preventDefault();
      e.stopPropagation();

      console.log('Close button clicked:', target);

      // Find the modal that contains this close button
      const modal = target.closest('.leadership-modal');
      if (modal && modal.id) {
        console.log(`Closing modal via button: ${modal.id}`);
        hideModal(modal.id);
      }
    }

    // Handle backdrop clicks
    else if (target.classList.contains('modal-backdrop')) {
      e.preventDefault();
      e.stopPropagation();

      const modalId = target.id.replace('-backdrop', '');
      if (modalId) {
        console.log(`Closing modal via backdrop: ${modalId}`);
        hideModal(modalId);
      }
    }
  });

  console.log(`Custom culture modals initialized for ${leadershipDivs.length} leadership items`);
});

